import { useEffect } from 'react';

import { Flex, Text } from '@chakra-ui/react';

import { h_400_14_135_28 } from '@/styles/fontStyles';

import { useFiltersBlock } from '../../../../../hooks/useFiltersBlock';
import { mockDataPanels } from '../mocksData/mockDataPanels';

export function PanelSelector() {
  const data = mockDataPanels();
  const { currentPanel, handlerSelectedPanel } = useFiltersBlock();

  const styleOuterFlex = {
    maxW: { base: '85%', md: 'unset' },
    gap: { base: '12px', md: '10px' },
    align: 'center',
    flexWrap: { base: 'wrap', md: 'nowrap' },
    justify: { base: 'center', md: 'center' },
  };
  const styleInnerFlex = (id) => {
    return {
      gap: '4px',
      align: 'center',
      color: currentPanel === id ? 'mainBlack' : 'gray',
      cursor: 'pointer',
      borderBottom: '2px solid',
      borderColor: currentPanel === id ? 'mainBlack' : 'transparent',
      transition: 'all 0.3s ease-in-out',
    };
  };

  useEffect(() => {
    handlerSelectedPanel(data[0]?.id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex {...styleOuterFlex}>
      {data?.map((el) => {
        const { id, title, icon: Icon } = el;
        return (
          <Flex
            key={'tabElement' + el?.id}
            {...styleInnerFlex(id)}
            onClick={() => {
              handlerSelectedPanel(id);
            }}
          >
            <Icon />
            <Text {...{ pt: '3px', ...h_400_14_135_28 }}>{title}</Text>
          </Flex>
        );
      })}
    </Flex>
  );
}
